module.exports = __webpack_public_path__ + "img/e-12.faa29b4c.jpg";